import { WorldTile } from "../../engine/map/LevelMap";
import { Directions } from "../../engine/space/directions";
import { AdjTypes, FloorTypes } from "./Map";

export const adjInCheck = (adj: AdjTypes) =>
  adj !== AdjTypes.WALL && adj !== AdjTypes.ONE_OUT;

export const adjOutCheck = (adj: AdjTypes) =>
  adj !== AdjTypes.WALL && adj !== AdjTypes.ONE_IN;

export const CheckMovement = {
  [Directions.Left]: (tile: WorldTile<FloorTypes, AdjTypes>) =>
    tile && adjOutCheck(tile.adj.left),
  [Directions.Up]: (tile: WorldTile<FloorTypes, AdjTypes>) =>
    tile && adjOutCheck(tile.adj.up),
  [Directions.Right]: (tile: WorldTile<FloorTypes, AdjTypes>) =>
    tile && adjOutCheck(tile.adj.right),
  [Directions.Down]: (tile: WorldTile<FloorTypes, AdjTypes>) =>
    tile && adjOutCheck(tile.adj.down),
  [Directions.UpLeft]: (tile: WorldTile<FloorTypes, AdjTypes>) =>
    tile && adjOutCheck(tile.adj.up) && adjOutCheck(tile.adj.left),
  [Directions.UpRight]: (tile: WorldTile<FloorTypes, AdjTypes>) =>
    tile && adjOutCheck(tile.adj.up) && adjOutCheck(tile.adj.right),
  [Directions.DownRight]: (tile: WorldTile<FloorTypes, AdjTypes>) =>
    tile && adjOutCheck(tile.adj.down) && adjOutCheck(tile.adj.right),
  [Directions.DownLeft]: (tile: WorldTile<FloorTypes, AdjTypes>) =>
    tile && adjOutCheck(tile.adj.down) && adjOutCheck(tile.adj.left),
} as const;
